import * as types from "../../mutation-types";
import FoodCategoriesProvider from "../../../providers/FoodCategoriesProvider";

// initial state
const state = {
	foodCategories:[],
	selectedFoodCategory: {}
};

// getters
const getters = {
	foodCategories: state => state.foodCategories,
	selectedFoodCategory: state => state.selectedFoodCategory
};

// actions
const actions = {
	// ingredients
	refreshFoodCategories({commit}) {
		return readAllFoodCategories(commit);
	},
	getFoodCategory: ({dispatch, getters}, foodCategory) => {
		return FoodCategoriesProvider.getFoodCategory(
			foodCategory.id,
			foodCategory.tenantId,
			getters.jwtToken
		).then((foodCategoryResponse)=>{
			return dispatch("refreshFoodCategory", {foodCategoryResponse});
		});
	},
	refreshFoodCategory({commit}, {foodCategoryResponse}){
		commit(types.REFRESH_FOOD_CATEGORY, foodCategoryResponse);
	}
};

/*
	Begining of a zone with a helper functions
 */

// export function for external use
export function readAllFoodCategories(commit){
	return FoodCategoriesProvider.getFoodCategories()
		.then(foodCategories => {
			return commit(types.REFRESH_FOOD_CATEGORIES, foodCategories);
		})
		.catch(()=>{
		});
}
/*
	End of a zone with a helper functions
 */

// mutations
const mutations = {
	[types.REFRESH_FOOD_CATEGORIES](state, foodCategories){
		const receivedArray = foodCategories.foodCategories.data.data.slice();
		state.foodCategories = receivedArray;
	},
	[types.REFRESH_FOOD_CATEGORY](state, foodCategoryResponse){
		const receivedArray = foodCategoryResponse.data.data.slice();
		state.selectedFoodCategory = receivedArray[receivedArray.length - 1];
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
